/**
 * ConnectButton — обёртка над TonConnectButton.
 *
 * TonConnectButton — стандартный UI компонент из @tonconnect/ui-react.
 * Сам показывает либо "Connect Wallet" если не connected, либо address
 * + dropdown с disconnect если connected.
 *
 * Использование: где-то в шапке или экране кошелька.
 * Стилизация автоматически адаптируется под Telegram theme.
 */

import { TonConnectButton } from '@tonconnect/ui-react';

export function ConnectButton() {
  return <TonConnectButton />;
}
